import React, { createContext, useState } from 'react';

// Create the context
export const VisiblityLoaderContext = createContext();

// Create the provider
export const VisiblityLoaderProvider = ({ children }) => {
  const [visiblityLoader, setVisiblityLoader] = useState(false);

  return (
    <VisiblityLoaderContext.Provider value={{ visiblityLoader, setVisiblityLoader }}>
      {children}
    </VisiblityLoaderContext.Provider>
  );
};